const normalizeBasePath = (path: string) => {
  if (!path || path === '/') {
    return '/';
  }
  return path.endsWith('/') ? path.slice(0, -1) : path;
};

const ensureLeadingSlash = (path: string) => {
  if (!path || path === '/') {
    return '/';
  }
  return path.startsWith('/') ? path : `/${path}`;
};

export const getAppBasePath = (): string => {
  if (typeof window !== 'undefined' && (window as any).__APP_BASE__) {
    return (window as any).__APP_BASE__ as string;
  }

  const globalValue =
    typeof globalThis !== 'undefined'
      ? ((globalThis as unknown) as { __APP_BASE__?: string }).__APP_BASE__
      : undefined;
  if (globalValue) {
    return globalValue;
  }

  return '/app/catalog';
};

export const buildAppPath = (path: string): string => {
  const base = normalizeBasePath(getAppBasePath());
  const normalizedPath = ensureLeadingSlash(path);

  if (normalizedPath === '/') {
    return base === '/' ? '/' : base;
  }

  const basePrefix = base === '/' ? '' : base;
  return `${basePrefix}${normalizedPath}`;
};

export const appBasePath = (): string => normalizeBasePath(getAppBasePath());

export default buildAppPath;
